export default __webpack_public_path__ + "static/media/pricing-3.3c78e968.svg";